// The reference collections that land in every device's OFFLINE CACHE — the canonical list.
//
// Extracted from prefetch.ts (0.12.7 Part E) with no change to its contents, so that
// database/verify-offline-cache-tiers.ts can import the REAL list rather than a transcription of
// it: prefetch.ts pulls in api.ts, which reads import.meta.env and cannot load outside vite.
//
// ⚠ ANYTHING A ROUTE BELOW RETURNS IS WRITTEN TO EVERY DEVICE. Contact PII (email / mobile / phone /
// ARN) must never appear in these responses, and the gate asserts it on the response SHAPE by
// driving each route's real handler stack. Adding an entry here extends the gate automatically.
//
// No imports — keep it that way, or the gate cannot load it.

export interface RefSpecEntry { path: string; collection: string; keyOf: (x: any) => string; singleton?: boolean }

// Same set + keys as the board's saveRefDataToCache (OpsBoard.tsx). The gate also scans every
// saveReference() call in the frontend and fails if one writes a collection not listed here.
export const REF_SPEC: RefSpecEntry[] = [
  { path: '/api/bases', collection: 'bases', keyOf: (b) => b.id },
  { path: '/api/aircraft', collection: 'aircraft', keyOf: (a) => a.registration },
  { path: '/api/assets', collection: 'assets', keyOf: (a) => a.id },
  { path: '/api/staff', collection: 'staff', keyOf: (s) => s.id },
  { path: '/api/students', collection: 'students', keyOf: (s) => s.id },
  { path: '/api/booking-kinds', collection: 'booking-kinds', keyOf: (k) => k.id },
  { path: '/api/training-activities', collection: 'training-activities', keyOf: (a) => a.id },
  { path: '/api/company-settings', collection: 'company-settings', keyOf: () => 'singleton', singleton: true },
];
